var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastQuarterMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 50,
    viewBox: "0 0 25 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 47.4686L24.9999 2.53144C25.0025 2.17441 24.9296 1.82093 24.786 1.49453C24.6424 1.16814 24.4315 0.876326 24.1672 0.638531C23.903 0.400737 23.5915 0.222422 23.2536 0.115454C22.9156 0.00848594 22.5589 -0.0246804 22.2073 0.0181737C16.1033 0.695192 10.4618 3.61875 6.36393 8.22862C2.26605 12.8385 -2.17664e-06 18.8104 -2.71775e-06 25C-3.25886e-06 31.1896 2.26605 37.1615 6.36393 41.7714C10.4618 46.3813 16.1033 49.3048 22.2073 49.9818C22.5589 50.0247 22.9156 49.9915 23.2536 49.8846C23.5915 49.7776 23.903 49.5993 24.1672 49.3615C24.4315 49.1237 24.6424 48.8319 24.786 48.5055C24.9296 48.1791 25.0025 47.8256 24.9999 47.4686Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastQuarterMoonIcon);
export default __webpack_public_path__ + "static/media/LastQuarterMoonIcon.7e47dafff0dbb8a6b8a2a2e90b0d4b0c.svg";
export { ForwardRef as ReactComponent };